import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SessionProvider } from './app/SessionProvider.js';
import { App } from './app/App.js';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </StrictMode>,
);
